<template>
  <div class="support">
    <div class="support-div">
      <div class="support-header">
        <h2>پشتیبانی</h2>
        <button
          class="close"
          @click.prevent="$router.push('/dashboard/support')"
        >
          <img
            src="@/assets/icons/Left.svg"
            alt=""
            style="transform: rotate(180deg)"
            class="whiteIMG"
          />
        </button>
      </div>
      <transition name="fade">
        <div class="message-body">
          <div class="title-massage">
            <div>
              <p>{{ tableTh[0] }}</p>
              <p class="body-massage">{{ header.subject }}</p>
            </div>
            <div>
              <p>{{ tableTh[1] }}</p>
              <p class="body-massage" style="text-align: right">
                {{ $G2J(header.createdAtDateTime, "enDateTime") }}
              </p>
            </div>
            <div>
              <p>{{ tableTh[2] }}</p>
              <p class="body-massage">{{ typeLabel(header.type) }}</p>
            </div>
            <div>
              <p>{{ tableTh[3] }}</p>
              <p class="body-massage">{{ statusLabel(header.status) }}</p>
            </div>
          </div>
          <div class="massages">
            <message
              v-for="(message, index) in messages"
              :key="index"
              :message="message"
              :index="index"
            />
          </div>
          <div class="send-massage">
            <div class="div-input">
              <input v-model="data.text" type="text" name="massage" />
              <label for="file">
                <InlineSvg
                  :src="require('@/assets/icons/paperclip.svg')"
                  fill="var(--fontcolor)"
                />
                <!-- <img
                  height="25px"
                  src="../../../assets/img/Support/Icon/Attach.svg"
                  alt=""
                /> -->
                <input
                  @change="uploadFile($event.target)"
                  id="file"
                  type="file"
                  name="file"
                  hidden
                />
              </label>
            </div>
            <button @click="sendMessage" :disabled="!data.text">ارسال</button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Message from "@/components/Panel/Support/message";
import InlineSvg from "vue-inline-svg";

export default {
  name: "SupportMassage",
  props: ["id"],
  components: { Message, InlineSvg },
  data() {
    return {
      massageID: 0,
      tableTh: ["موضوع", "زمان", "بخش", "وضعیت"],
      header: {},
      messages: [],
      path: "",
      load: "",
      loadedpicture: 0,
      data: {
        text: "",
        file: "",
      },
    };
  },
  computed: {
    statusLabel() {
      const a = {
        OPENED: "باز",
        PENDING: "در حال بررسی",
        CUSTOMER_ANSWERED: "پاسخ شما",
        ADMIN_ANSWERED: "پاسخ ادمی",
      };
      return (e) => a[e];
    },
    typeLabel() {
      const a = {
        TECHNICAL: "فنی",
        GENERAL: "عمومی",
      };
      return (e) => a[e];
    },
  },
  methods: {
    async getData() {
      this.state.loading = true;
      const res = await this.$axios.get("/tickets/message/" + this.id);
      this.header = res.ticketDTO;
      this.messages = res.pageDTO.content.reverse();
    },
    async sendMessage() {
      let formData = new FormData();
      formData.append("text", this.data.text);
      const res = await this.$axios.post(
        "/tickets/message/" + this.id,
        formData
      );
      console.log(res);
      this.messages.push(res.baseDTO);
    },
    async sendFile() {
      let formData = new FormData();
      formData.append("file", this.data.file);
      const res = await this.$axios.post(
        "/tickets/message/" + this.id,
        formData
      );
      console.log(res);
      this.messages.push(res.baseDTO);
    },
    uploadFile(evt) {
      this.state.loading = true;
      let file = evt.files[0];
      this.data.file = file;
      let fileReader = new FileReader();
      fileReader.addEventListener("loadstart", (event) => {
        this.loadedpicture = ((event.loaded / event.total) * 100).toFixed(0);
      });
      fileReader.addEventListener("progress", (event) => {
        this.loadedpicture = ((event.loaded / event.total) * 100).toFixed(0);
      });
      fileReader.addEventListener("load", (event) => {
        this.loadedpicture = ((event.loaded / event.total) * 100).toFixed(0);
        this.path = event.target.result;
        this.sendFile();
      });
      fileReader.readAsDataURL(file);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.support {
  .support-div {
    background-color: var(--box);
    border-radius: 5px;
    margin-bottom: 10px;
    width: 100%;
    padding: 20px;

    .support-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .close {
        width: 43px;
        height: 43px;
        border: 1px solid var(--yellow);
        border-radius: 5px;
        cursor: pointer;

        img {
          width: 10px;
        }
      }

      h2 {
      }

      button {
        color: var(--white);
        background-color: var(--primary-color);
        padding: 9px;
        display: flex;
        border-radius: 5px;
        transition: all 0.3s ease;
        height: 43px;
        width: 187px;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        transform: rotate(180deg);

        &:hover {
          background-color: var(--dark-primary);
          outline: none;
        }
      }
    }
  }
}

.title-massage {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;

  > * {
    flex-basis: 170px;
    flex-grow: 1;
    flex-shrink: 1;

    &:first-of-type {
      flex-basis: 170px;
      flex-grow: 20;
    }
  }
}

.body-massage {
  background-color: var(--background);
  padding: 10px;
  border-radius: 5px;
}

.massages {
  font-size: 14px;
  padding: 0 5px;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  div {
    position: relative;
  }
}

.send-massage {
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 20px;

  .div-input {
    flex-grow: 1;
    position: relative;

    input {
      width: 100%;
      padding: 10px;
      opacity: 0.7;
      border-radius: 5px;
      color: var(--fontcolor);
      padding-left: 40px;
    }

    label {
      position: absolute;
      left: 5px;
      top: 8px;
      width: 25px;
      height: 25px;
    }
  }

  button {
    width: 25%;
    display: block;
    color: var(--white);
    background-color: var(--primary-color);
    border-radius: 5px;
    transition: all 0.3s ease;
    text-align: center;
    height: 43px;
    margin: 0 5px 0 auto;

    &:hover {
      background-color: var(--dark-primary);
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
</style>
